// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React, { useCallback } from 'react'
import { object, string } from 'prop-types'
import { useSelector } from 'react-redux'
import AttachmentItem from './AttachmentItem'
import { removeAttachmentFromComment } from './helpers'

// NOTE - this cell formatter (module) does not expose an exportValue method
// as a result, if you try to export a data table which uses this cell,
// the CSV will return 'NOT MAPPED'.

const FormatAttachment = props => {
  const {
    customProps,
    idRoot,
    rowData,
  } = props

  const {
    commentType,
    deleteAttachment,
    updateSingleComment,
  } = customProps

  // the comment file id property is unique based on the entity type that the comment belongs to.
  const commentFileIdKey = `${commentType}CommentFileId`

  const canDeleteAttachment = useSelector(({ user }) => user.get('userId') === rowData.createUserId)

  const removeSingleAttachmentFromComment = useCallback(commentFileId => (
    updateSingleComment(removeAttachmentFromComment(rowData, commentFileIdKey, commentFileId))
  ), [updateSingleComment, rowData, commentFileIdKey])

  return (
    <ul>
      {rowData.attachments.map((d, i) => (
        <AttachmentItem
          key={d[commentFileIdKey]}
          canDeleteAttachment={canDeleteAttachment}
          commentFileId={d[commentFileIdKey]}
          deleteAttachment={deleteAttachment}
          fileName={d.fileName}
          fileUrl={d.fileUrl}
          idRoot={`${idRoot}-${i}`}
          removeSingleAttachmentFromComment={removeSingleAttachmentFromComment} />
      ))}
    </ul>
  )
}

FormatAttachment.propTypes = {
  columnKey: string.isRequired,
  customProps: object.isRequired,
  idRoot: string.isRequired,
  rowData: object.isRequired,
}

export default FormatAttachment
